export const FEATURE_NAME = '@zerops/zef/dialog';
